import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useState } from 'react';
import { Collapse, Alert as MuiAlert, alertClasses as MuiAlertClasses } from '@mui/material';
import CheckCircleOutline from 'mdi-material-ui/CheckCircleOutline';
import CloseIcon from 'mdi-material-ui/Close';
import MenuDown from 'mdi-material-ui/MenuDown';
import MenuUp from 'mdi-material-ui/MenuUp';
import { combineSx } from '../../utils';
import { IconButton } from '../IconButton';
import { Stack } from '../Stack';
import { Button } from '../Button';
import { Typography } from '../Typography';
export const alertClasses = {
    message: MuiAlertClasses.message,
    action: MuiAlertClasses.action
};
export const Alert = /*#__PURE__*/ forwardRef(function Alert({ severity = 'success', isIconHidden, isSquare, Action, children, onClose, MoreDetails, Header, sx, ...props }, ref) {
    const [detailsVisible, setDetailsVisible] = useState(false);
    const icon = severity === 'success' ? /*#__PURE__*/ _jsx(CheckCircleOutline, {}) : undefined;
    const ariaLabel = props['aria-label'];
    return /*#__PURE__*/ _jsxs(MuiAlert, {
        sx: combineSx({
            [`&.${MuiAlertClasses.root}`]: {
                alignItems: 'flex-start'
            }
        }, sx),
        severity: severity,
        square: isSquare,
        ...props,
        ref: ref,
        icon: isIconHidden ? false : icon,
        "aria-label": ariaLabel,
        action: Action || onClose ? // The 2px vertical margin is necessary to make the action buttons look centered when the
        // alert doesn't grow vertically
        /*#__PURE__*/ _jsxs(Stack, {
            direction: "row",
            gap: 1,
            my: "2px",
            children: [
                Action,
                onClose && /*#__PURE__*/ _jsx(IconButton, {
                    "aria-label": ariaLabel ? `close ${ariaLabel}` : `close alert`,
                    onClick: onClose,
                    children: /*#__PURE__*/ _jsx(CloseIcon, {})
                })
            ]
        }) : undefined,
        children: [
            Header && /*#__PURE__*/ _jsx(Typography, {
                fontWeight: "bold",
                variant: "h4",
                children: Header
            }),
            children,
            MoreDetails && /*#__PURE__*/ _jsxs(Stack, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: ()=>setDetailsVisible(!detailsVisible),
                        StartIcon: detailsVisible ? /*#__PURE__*/ _jsx(MenuUp, {}) : /*#__PURE__*/ _jsx(MenuDown, {}),
                        variant: "tertiary",
                        size: "small",
                        sx: {
                            width: 'fit-content',
                            padding: 0,
                            fontSize: (theme)=>theme.typography.body2,
                            fontWeight: 'bold'
                        },
                        children: "More details"
                    }),
                    /*#__PURE__*/ _jsx(Collapse, {
                        in: detailsVisible,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            sx: {
                                marginLeft: '28px'
                            },
                            variant: "body2",
                            children: MoreDetails
                        })
                    })
                ]
            })
        ]
    });
});

//# sourceMappingURL=Alert.js.map